import "./auth/configureAuth";
import React from "react";
import ReactDOM from "react-dom/client";
// Import UI toolkit styles first for proper cascade
import "@etlyn/ui-toolkit/lib/globals.css";
// Keep Mantine imports for now until full app migration
import "@mantine/core/styles.css";
import "@mantine/tiptap/styles.css";
import "@mantine/carousel/styles.css";
import "@mantine/dropzone/styles.css";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { MantineProvider } from "@mantine/core";
import { ThemeProvider } from "styled-components";
import { theme } from "./theme";
import "./index.css"; // Import app-specific styles last
import { startAnalytics } from "./analytics";

const stopAnalytics = startAnalytics();
import.meta.hot?.dispose(stopAnalytics);

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <MantineProvider>
      <ThemeProvider theme={theme}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </ThemeProvider>
    </MantineProvider>
  </React.StrictMode>,
);
